<template>
  <form @submit.prevent="addItem">
    <div class="ui grid container">
        <div class="row">
          <fieldset class="ui sixteen wide column">
            <label>Task Name</label>
            <div><input v-model="taskName" placeholder="Do Something" required></input></div>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="ui sixteen wide column">
            <label>Resource Url</label>
            <div><input v-model="resourceUrl" placeholder="http://bla.bla" required></input></div>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="ui sixteen wide column">
            <div><input class="ui button" type="submit"></div>
          </fieldset>
        </div>
    </div>
  </form>
</template>

<script>
import { db, courseRef } from '../db';
import Markdown from './Markdown.vue';
export default {
  name: 'taskform',
  data () {
    return {
      taskName: '',
      resourceUrl: ''
    }
  },
  firebase: {
    items: courseRef.child('checkpoints')
  },
  methods: {
    addItem () {
      this.$firebaseRefs.items.child('en').push({
        task: this.taskName,
        resourceUrl: this.resourceUrl
      })
      this.taskName = '';
      this.resourceUrl = '';
    }
  },
  components: { Markdown }
}
</script>

<style scoped>
form {
    padding: 1em;
}
fieldset {
    border: none;
    margin: 1em;
}
label {
    font-weight: 700;
    line-height: 3em;
}
input {
    padding: 1em;
    width: 100%;
}
textarea {
    padding: 1em;
    width: 100%;
    height: 300px;
    resize: none;
}
.preview-area {
    padding: 4em 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/TaskForm.vue